import { http } from '../../config/axios'

export default function postSaldoClienteCompra(saldoClienteCompra: any): Promise<string> {
  return http
    .post('api/cliente-saldo-compra', saldoClienteCompra)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post saldoClienteCompra', error)
      throw Error(error.response.data)
    })
}
